__turbopack_context__.v({
  "counterModalOfferFormShippingText": "BjUVla_counterModalOfferFormShippingText",
  "counterOfferModalFormSubmitButton": "BjUVla_counterOfferModalFormSubmitButton",
  "counterOfferModalFormTipText": "BjUVla_counterOfferModalFormTipText",
});
